import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { HelpSectionSwitcher } from '@features/help/section-switcher';
import { steamHelpSections } from '../config/sections';
const SteamHelp: FC = () => <SteamHelpWrapper>
    <HelpSectionSwitcher sections={steamHelpSections} />
  </SteamHelpWrapper>;
export default SteamHelp;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const SteamHelpWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SteamHelpWrapper",
  class: "sqfabkl",
  propsAsIs: false,
  vars: {
    "sqfabkl-0": [_exp()]
  }
}));

require("./SteamHelp.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamHelp.tsx");